<section class="section">
    <div class="section-header">
      <h2>Application Type</h2>
      <p>Select between New Drug Application (NDA) or Supplemental NDA (sNDA)</p>
    </div>
    
    <div class="type-selection-grid">
      <div 
        class="type-card" 
        (click)="selectType('NDA')">
        <div class="type-icon">
          <i class="fas fa-plus-circle"></i>
        </div>


        <h3>NDA</h3>
        <p>New Drug Application</p>
        <div class="type-description">
          Applications for new pharmaceutical products
        </div>
      </div>
      
      <div 
        class="type-card" 
        [class.selected]="selectedType === 'sNDA'"
        (click)="selectType('sNDA')">
        <div class="type-icon">
          <i class="fas fa-edit"></i>
        </div>
        <h3>sNDA</h3>
        <p>Supplemental New Drug Application</p>
        <div class="type-description">
          Modifications to existing approved drugs
        </div>
      </div>
    </div>
  </section>
  